import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as L from 'leaflet';

@Injectable({
    providedIn: 'root'
})
export class GeolocationService {
    constructor(private http: HttpClient) {}
    private readonly R = 6371000; // Raio da Terra em metros
     private map!: L.Map;

    getCountry() {
        return this.http.get('https://get.geojs.io/v1/ip/geo.json'); // API de geolocalização
    }

    /**
   * Calcula a distância entre 2 pontos usando Haversine
   * @param lat1 latitude do ponto 1
   * @param lon1 longitude do ponto 1
   * @param lat2 latitude do ponto 2
   * @param lon2 longitude do ponto 2
   * @returns distância em metros
   */
  distanceCalculate(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const toRad = (value: number) => (value * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return this.R * c;
  }



   userInsideRay(lat: number, lon: number, ray: number): Promise<{ success: boolean, type: string, message: string }> {
        return new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition(pos => {
            const userLat = pos.coords.latitude;
            const userLon = pos.coords.longitude;

            const distance = this.distanceCalculate(userLat, userLon, lat, lon);

            if (distance <= ray) {
                resolve({ success: true, type: "success", message: "Dentro do raio" });
            } else {
                resolve({ success: false, type: "success", message: "Fora do raio" });
            }
            }, err => {
                resolve({ success: false, type: "error", message: "Erro ao obter localização: " + err.message });
            });
        });

    }

    renderMap(
        mapId: string,
        destino: [number, number],
        raio: number
    ): void {


      

        if (this.map) {
            this.map.remove();
        }

        // cria o mapa no destino inicialmente
        this.map = L.map(mapId).setView(destino, 16);

        // camada base OSM
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap'
        }).addTo(this.map);

        // ícone do destino
        const destinoIcon = L.icon({
            iconUrl: 'assets/img/pin-ft.png',
            iconSize: [100, 88],
            iconAnchor: [50, 88],
            popupAnchor: [0, -40]
        });

        // marcador do destino
        L.marker(destino, { icon: destinoIcon })
            .addTo(this.map)
            .bindPopup("Evento")
            .openPopup();

        // círculo de raio
        L.circle(destino, { radius: raio, color: "red", fillOpacity: 0.2 })
            .addTo(this.map);

        // depois tenta obter a localização do usuário
        navigator.geolocation.getCurrentPosition(pos => {
            const userLat = pos.coords.latitude;
            const userLon = pos.coords.longitude;
            const userLatLng: L.LatLngExpression = [userLat, userLon];

            // ícone do usuário
            const userIcon = L.icon({
            iconUrl: 'assets/img/pin-user-map.png',
            iconSize: [64, 64],
            iconAnchor: [32, 64],
            popupAnchor: [0, -40]
            });

            // marcador usuário
            L.marker(userLatLng, { icon: userIcon })
            .addTo(this.map)
            .bindPopup("Você está aqui")
            .openPopup();

            // 👉 ajusta o mapa para mostrar usuário + destino
            const bounds = L.latLngBounds([destino, userLatLng]);
            this.map.fitBounds(bounds, { padding: [50, 50] });
        }, err => {
            console.error("Erro ao obter localização:", err.message);
        });
    }


}